// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getDelayMitigationEffort(projectId: string, method: 'calendar' | 'task'): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/delay_mitigation?method=${method}`);
}
